var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesSticker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.44444,
    y: -4.44444,
    width: 48.8889,
    height: 48.8889
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.22px)",
      clipPath: "url(#bgblur_0_5445_229157_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 4.44444,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1853 22.0374V16.9448C30.1853 11.8522 28.1483 9.81518 23.0557 9.81518H16.9446C11.852 9.81518 9.81494 11.8522 9.81494 16.9448V23.0559C9.81494 28.1485 11.852 30.1855 16.9446 30.1855H22.0372",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1853 22.0374H26.1112C23.0556 22.0374 22.0371 23.0559 22.0371 26.1115V30.1855L30.1853 22.0374Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5445_229157_clip_path",
    transform: "translate(4.44444 4.44444)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesSticker);
export default __webpack_public_path__ + "static/media/stories-sticker.3e7132a2ec4c14731103032602088466.svg";
export { ForwardRef as ReactComponent };